import React from "react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { IconButton } from "@mui/material";
import { KeyValue } from "@/main/models/common";
import * as S from "./styles";

export interface ICategory extends KeyValue {
	subCategories?: ICategory[];
}

interface IOptionCategoryProps {
	category: ICategory;
	selectedCategory?: ICategory | null;
	selectedParentCategory?: ICategory | null;
	handleSelectCategory: (selected: ICategory | null) => void;
	handleSelectCategoryParent: (selected: ICategory | null) => void;
}

function OptionCategory({
	category,
	selectedCategory = null,
	selectedParentCategory = null,
	handleSelectCategoryParent,
	handleSelectCategory,
}: IOptionCategoryProps) {
	function handleClickCategory(categoryChanged: ICategory) {
		if (categoryChanged.key === selectedCategory?.key) {
			handleSelectCategory(null);
			handleSelectCategoryParent(null);
			return;
		}
		if (categoryChanged.subCategories) {
			handleSelectCategoryParent(categoryChanged);
		}
		handleSelectCategory(categoryChanged);
	}

	function handleClearCategory(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.stopPropagation();
		handleSelectCategory(null);
	}

	const hasSelected = selectedCategory !== null ? selectedCategory.key === category.key : false;
	const showSubCategories = hasSelected && category.subCategories && category.subCategories.length > 0;
	const hasSubCategorySelected =
		category.subCategories &&
		selectedParentCategory?.key === category.key &&
		category.subCategories.some((item) => item.key === selectedCategory?.key);
	const hasSelectedSubCategory = (categoryCheck: ICategory) => categoryCheck.key === selectedCategory?.key;

	return (
		<S.Container>
			<S.AreaButton>
				{hasSelected && (
					<S.CloseButton>
						{" "}
						<IconButton onClick={handleClearCategory} id={`id-createOrder-button-remove-category-${category.value}`}>
							<CloseOutlined fontSize="small" />
						</IconButton>
					</S.CloseButton>
				)}
				<S.LinkButton
					id={`id-createOrder-button-category-${category.value}`}
					selected={hasSelected}
					onClick={() => handleClickCategory(category)}
				>
					{category.value}
				</S.LinkButton>
			</S.AreaButton>

			<S.AreaSubCategory>
				{(showSubCategories || hasSubCategorySelected) &&
					category.subCategories?.map((item) => (
						<S.AreaButton key={item.key}>
							{hasSelectedSubCategory(item) && (
								<S.CloseButton>
									<IconButton
										onClick={handleClearCategory}
										id={`id-createOrder-button-remove-subCategory-${category.value}`}
									>
										<CloseOutlined fontSize="small" />
									</IconButton>
								</S.CloseButton>
							)}
							<S.LinkButton
								id={`id-createOrder-button-subcategory-${item.value}`}
								selected={selectedCategory?.key === item.key}
								onClick={() => handleClickCategory(item)}
							>
								{item.value}
							</S.LinkButton>
						</S.AreaButton>
					))}
			</S.AreaSubCategory>
		</S.Container>
	);
}

export default OptionCategory;
